import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar } from "@mui/material";
import React, { useState, useContext, useEffect } from "react";
import profilePic from "../../../assets/user.jpg"
import { useAppSelector } from "../../../store/hooks/hooks";
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import AddHomeRoundedIcon from '@mui/icons-material/AddHomeRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import './sideNav.scss'
import desk from '../../../assets/Desk.png'
import { NavigationContext } from "../admin";


const drawerWidth = 240;
const SideNav = (props: any) => {
    const userDetails = useAppSelector((state: any) => state.user.user.result)
    const isAdmin = useAppSelector((state: any) => state.user.user.isAdmin)
    const [selectedItem, setSelectedItem] = useState(0)
    const navContext = useContext(NavigationContext);

    const SwitchListIcons = (item: string, index: number) => {
        switch (item) {
            case 'Dashboard':
                return <DashboardRoundedIcon className={selectedItem === index ? "selectedIndex" : "gray-color"}></DashboardRoundedIcon>
            case 'Requests':
                return <AddHomeRoundedIcon className={selectedItem === index ? "selectedIndex" : "gray-color"}></AddHomeRoundedIcon>
            case 'Meetings':
                return <CalendarMonthRoundedIcon className={selectedItem === index ? "selectedIndex" : "gray-color"}></CalendarMonthRoundedIcon>
            case 'Students':
                return <GroupRoundedIcon className={selectedItem === index ? "selectedIndex" : "gray-color"}></GroupRoundedIcon>
            case 'Scheduler':
                return <MapRoundedIcon className={selectedItem === index ? "selectedIndex" : "gray-color"}></MapRoundedIcon>

        }
    }
    const DrawerContainer = (props: any) => {
        return (
            <>
                <Toolbar />
                <Toolbar className="py-3">
                    <div className="flex justify-content-around w-100">
                        <img src={profilePic} alt="profilePicture" className="sideNavProfilePic"></img>
                        <div className="align-self-center flex flex-column">
                            <p className="font-weight-700 m-0 sideNavContent">{userDetails.first_name} {userDetails.last_name}</p>
                            <p className="sideNavSubContent body-p gray-color subTitle m-0">Placement Admin</p>
                        </div>
                    </div>
                </Toolbar>
                <div className="px-2">
                    <List>
                        <ListItem>
                            <ListItemText >
                                <p className="font-weight-700 m-0">Menu</p>
                            </ListItemText>
                        </ListItem>
                        {['Dashboard', 'Requests', 'Meetings', 'Scheduler'].map((text, index) => (
                            <ListItem key={text} disablePadding onClick={() => {
                                setSelectedItem(index)
                                navContext.assignContent(text)
                                props.onClose()
                                // props.sideNavNavigation(text)
                            }}>
                                <ListItemButton>
                                    <ListItemIcon>
                                        {SwitchListIcons(text, index)}
                                    </ListItemIcon>
                                    <ListItemText>
                                        <p className={selectedItem === index ? "selectedIndex  m-0" : "gray-color m-0"}>{text}</p>
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                        ))}
                        <ListItem className="mt-4">
                            <img src={desk} className="deskImage"></img>
                        </ListItem>

                    </List>
                </div>
            </>
        )
    }
    const permantDrawer = () => {
        return (
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }} className="flex justify-content-around sidenavContainer"
                variant="permanent"
                anchor="left"
            >
                <DrawerContainer onClose={() => { }}></DrawerContainer>
            </Drawer>
        )
    }
    const MobDrawer = (props: any) => {
        const [open, setOpen] = useState(props.open)
        const handleDrawerToggle = () => {
            setOpen((prevState: boolean) => !prevState);
            props.navbarReset()
        }
        return (
            <Drawer
                variant="temporary"
                open={open}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
            >
                <DrawerContainer onClose={handleDrawerToggle}></DrawerContainer>
            </Drawer>
        )
    }

    return (
        <>
            <>
                {permantDrawer()}
            </>
            <>
            <MobDrawer open={props.open} navbarReset={props.navbarReset}></MobDrawer> 
            </>
        </>
       
    )
}
export default SideNav;